import { styled, Grid as MuiGrid } from "@mui/material";
import { supernova, white, cancelGray } from "../../../../assets/styles/colors";

const PREFIX = "UserProfileActionsStyles";
export const classes = {
  cancelButton: `${PREFIX}-cancelButton`,
  saveButton: `${PREFIX}-saveButton`,
  markedButton: `${PREFIX}-markedButton`
};

export const Grid = styled(MuiGrid)(() => ({
  [`& .${classes.cancelButton}`]: {
    backgroundColor: cancelGray
  },
  [`& .${classes.saveButton}`]: {
    color: white
  },
  [`& .${classes.markedButton}`]: {
    backgroundColor: supernova
  }
}));
